import Grid from "./Grid";
import PropTypes from "prop-types";
import React from "react";
import TakebackFormCell from "./TakebackFormCell";

function TwoColumnFormRow({ col1, col2, ...props }) {
  return (
    <Grid
      gridTemplateColumns="1fr 1fr"
      gridColumnGap={["12px", 20, null, null]}
      {...props}
    >
      <TakebackFormCell>{col1}</TakebackFormCell>
      <TakebackFormCell>{col2}</TakebackFormCell>
    </Grid>
  );
}

TwoColumnFormRow.propTypes = {
  col1: PropTypes.node.isRequired,
  col2: PropTypes.node.isRequired,
};

export default TwoColumnFormRow;
